import {CaptionListProps} from "../types/caption";
import { InitializeProps } from "../types/initialize";

function digitalClock(num: number, numberOfZeroes: number = 2): string {
  let i = 1
  while (i <= numberOfZeroes) {
    const tens = Math.pow(10, i)

    if (num >= tens) i++
    else break
  }

  return '0'.repeat(numberOfZeroes - i) + String(num)
}

export function second2timestamp(total_seconds: number, mode: 'minute' | 'hours' | 'complete' | 'complete_array'): any {

  const milliseconds = Math.floor((total_seconds % 1) * 1000),
    seconds = Math.floor(total_seconds % 60),
    minutes = Math.floor((total_seconds % 3600) / 60),
    hours = Math.floor(total_seconds / 3600)

  if (mode === 'minute')
    return `${digitalClock(minutes)}:${digitalClock(seconds)}`
  else if (mode === "hours")
    return `${digitalClock(hours)}:${digitalClock(minutes)}:${digitalClock(seconds)}`
  else if (mode === 'complete')
    return `${digitalClock(hours)}:${digitalClock(minutes)}:${digitalClock(seconds)},${digitalClock(milliseconds, 3)}`
  else if (mode == 'complete_array')
    return [{"hours":('00' + hours).slice(-2), "minutes":('00' + minutes).slice(-2), "seconds":('00' + seconds).slice(-2), "milliseconds":('000' + milliseconds).slice(-3)}];

  else
    return ''
}

export function validateCaptionList(captionList: CaptionListProps[], captionConfig: InitializeProps) {

  return captionList.map((v, index) => {
    if(index === 0) {
      return {
        ...v,
        isOverlap : false,
        isTooShortTime: false,
        isTooLongTime : false,
        isTooLongText : false,
      }
    }

    const duration = (v.endTime as number) - (v.startTime as number)
    const nextCaption = captionList.at(index + 1)
    const prevCaption = captionList.at(index - 1)

    const isOverlap = (nextCaption && (0 > (nextCaption.startTime as number) - (v.endTime as number) -  - 0.07))
                      || (prevCaption && (0 > (v.startTime as number) - (prevCaption.endTime as number) - 0.07))
    ? true
    : false

    return {
      ...v,
      isOverlap,
      isTooShortTime : duration < captionConfig.caption_min_time,
      isTooLongTime : duration > captionConfig.caption_max_time,
      isTooLongText : v.caption.length > captionConfig.text_limit,
    }
  })
}

export function timestamp2seconds(timestamp: string): number {

  const hours = Number(timestamp.slice(0, 2)),
    minutes = Number(timestamp.slice(3, 5)),
    seconds = Number(timestamp.slice(6, 8)),
    milliseconds = Number(timestamp.slice(9))

  return (hours * 60 * 60) + (minutes * 60) + (seconds) + (milliseconds / 1000)
}



export function seconds2Percent (seconds:number, duration:number ) : number {

  let handlerPercent = (seconds / duration) * 100;

  return handlerPercent;

}


export function percent2Seconds (percent:number|number[], duration:number ) : number {

  let num = Number(percent);
  let seekTime = duration * (num/100);

  return seekTime;

}


export function export2srt(captions: CaptionListProps[]): string {
  return captions.filter((segment, index) => {
    if(index === 0) return false
    else return true
  }).map((c, i) =>
    `${i + 1}\n${c.time_ini.replace(".",",")} --> ${c.time_end.replace(".",",")}\n${c.caption}`)
    .join('\n\n')
}


